import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {AccountType} from '../../../../../../../../../api';
import {MultiDropdown} from '../../../../../../../../components/multi-dropdown/multi-dropdown';
import {Dropdown} from '../../../../../../../../components/dropdown/dropdown';


interface AccountTypeOption {
  id: string;
  name: string;
}

@Component({
  selector: 'elcia-account-type-dropdown',
  imports: [Dropdown, MultiDropdown, TranslatePipe],
  templateUrl: './account-type-dropdown.html',
})
export class AccountTypeDropdown {
  private readonly translate = inject(TranslateService);
  private readonly langChange = toSignal(this.translate.onLangChange, {initialValue: null});

  control = input.required<FormControl>();
  isMulti = input.required<boolean>();

  protected readonly options = computed<AccountTypeOption[]>(() => {
    this.langChange();
    return Object.values(AccountType).map(type => ({
      id: type,
      name: this.translate.instant(`account-code-type.${type}`),
    }));
  });
}
